import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

import { getPopupWindowProps } from '../common/popupService';
import { MARKETPLACE_START_FREE_TRIAL } from '../common/routes';
import { getWindowScreen } from '../common/screenWrapper';
import '@rio-cloud/iframe-resizer/child'; // Required for resizing when included as iframe

import { useStartFreeTrialTrackingAttributes } from '../common/utils/googleTagManagerAttributes';
export function FreeTrialButton() {
    const targetPath = `/${MARKETPLACE_START_FREE_TRIAL}`;
    const windowId = 'free-trial';
    const { windowName, sizeString } = getPopupWindowProps(getWindowScreen(), windowId, 'freeTrialButton');
    const visibilityTrackingAttributes = useStartFreeTrialTrackingAttributes('visibility');
    const clickTrackingAttributes = useStartFreeTrialTrackingAttributes('click');

    return (
        <div
            className={'buyButtonLink'}
            style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
            {...visibilityTrackingAttributes}
        >
            <Button
                type='button'
                className={'btn btn-secondary text-size-18'}
                onClick={() => window.open(targetPath, windowName, sizeString)}
                autoTrackingKey={'marketplace.freeTrial.button'}
                {...clickTrackingAttributes}
            >
                <FormattedMessage id={'intl-msg:marketplace.freeTrial.button'} />
            </Button>
        </div>
    );
}
